import Layout from 'components/Layout';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import WebsiteTpl from 'templates/WebsiteTpl';

const Tpl = props => (
  <Layout location={props.location}>
    <WebsiteTpl {...props} />
  </Layout>
);
const Index = props => {
  const data = useStaticQuery(graphql`
    query WebsiteQuery {
      websitePage: websiteJson {
        title
        meta {
          description
          breadcrumb {
            link
            text
          }
        }
        banner {
          heading
          content
          img {
            publicURL
          }
          isNew
          imageAsBg
          cta {
            url
            text
            openNew
          }
        }
        featuresHeading {
          heading
          desc
        }
        featuresList {
          heading
          content
          img {
            publicURL
          }
        }
        threeCardsHeading {
          heading
          desc
        }
        threeCardsList {
          heading
          description
          img {
            publicURL
          }
        }
        twoColsHeading {
          heading
          desc
        }
        twoCols {
          img {
            publicURL
          }
          list {
            heading
            content
          }
        }
        videoHeading {
          heading
          desc
        }
        videoList {
          heading
          description
        }
        videolink {
          publicURL
        }
        exampleHeading {
          heading
          desc
        }
        exampleList {
          heading
          desc
          img {
            publicURL
          }
        }
        exampleTags
        CTAText {
          heading
          btnText
          wrapper
        }
        cards4 {
          heading
          desc
          list {
            heading
            desc
            img { publicURL }
            color
          }
        }
        footer {
          heading
          description
          link
          ctaText
          image {
            publicURL
          }
          list {
            heading
            desc
          }
        }
      }
    }
  `);
  return ( <Tpl data={data} {...props} />);
};

Tpl.propTypes = {
  location: PropTypes.object,
};

export default Index;
